module.exports = __webpack_public_path__ + "assets/img/bp_d_i_18.317f29d2.jpg";